/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState, useRef } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import { Td } from './css';

import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';
import getFormattedPricing from '../../utils';

const RatePlanTableSubRow = ({
  orderType,
  productSelected,
  accountType,
  rateplanName,
  deviceData,
  fiftyPercentInUS,
  viewType,
  ratePlans,
  setRatePlans,
  rateplanType
}) => {
  const {
    fields: { deviceName, terms }
  } = deviceData;
  const localizedStrings = useLocalizedStringsContext();
  const {
    contentfulValues: {
      valueCorporate,
      valueRaven,
      valueBusinessPersonal,
      valueBusinessRegular,
      value2year,
      value3year,
      valueRenewal,
      valueMTM
    }
  } = localizedStrings;

  const [term, setTerm] = useState(() =>
    _.get(ratePlans, `${rateplanName}.${deviceName}.term`, '')
  );
  const [quantity, setQuantity] = useState(() =>
    _.get(ratePlans, `${rateplanName}.${deviceName}.quantity`, 0)
  );
  const [unitPrice, setUnitPrice] = useState(() =>
    _.get(ratePlans, `${rateplanName}.${deviceName}.unitPrice`, 0)
  );
  const rowRef = useRef(false);

  const updateUnitPrice = () => {
    const selectedTermData = terms.filter(row => row.fields.termName === term);

    const unitPriceKey = fiftyPercentInUS
      ? 'termPrice50PrecentUs'
      : 'termPrice';
    const unitPriceValue = _.get(
      selectedTermData,
      `0.fields.${unitPriceKey}`,
      0
    );
    setUnitPrice(unitPriceValue);
  };

  const getTerms = () => {
    let updatedTerms = [...terms];
    if ([valueBusinessPersonal, valueBusinessRegular].includes(accountType))
      updatedTerms = updatedTerms.filter(
        termItem => _.get(termItem, 'fields.termName') !== value3year
      );
    if (![valueBusinessPersonal, valueBusinessRegular].includes(accountType))
      updatedTerms = updatedTerms.filter(
        termItem => _.get(termItem, 'fields.termName') !== value2year
      );
    if (viewType === 'simpleView' || orderType === valueRenewal)
      updatedTerms = updatedTerms.filter(
        termItem => _.get(termItem, 'fields.termName') !== valueMTM
      );

    return updatedTerms;
  };

  useEffect(() => {
    updateUnitPrice();
    if (!term) setQuantity(0);
  }, [term, fiftyPercentInUS]);

  useEffect(() => {
    const updatedRatePlans = {
      ...ratePlans,
      [rateplanName]: {
        ...ratePlans[rateplanName],
        [deviceName]: {
          term,
          quantity,
          unitPrice,
          fiftyPercentInUS,
          rateplanType
        }
      }
    };

    setRatePlans(updatedRatePlans);
  }, [term, quantity, unitPrice, fiftyPercentInUS]);

  useEffect(() => {
    if (viewType && rowRef.current) {
      setTerm('');
      setQuantity(0);
      setUnitPrice(0);
    }
    rowRef.current = true;
  }, [viewType]);

  useEffect(() => {
    if (productSelected === valueRaven && rowRef.current) {
      setTerm('');
      setQuantity(0);
      setUnitPrice(0);
    }
    rowRef.current = true;
  }, [accountType]);

  return (
    <>
      <Td>
        <select onChange={e => setTerm(e.target.value)} value={term}>
          <option value="">Select Term...</option>
          {getTerms().map(termItem => {
            return (
              <option
                key={_.get(termItem, 'sys.id', '')}
                value={_.get(termItem, 'fields.termName')}
              >
                {_.get(termItem, 'fields.termName')}
              </option>
            );
          })}
        </select>
      </Td>
      <Td>{deviceName}</Td>
      <Td>
        <input
          disabled={term === ''}
          style={{ background: term ? '#fff' : '#f3f3f3' }}
          className="frg-input-field color-light"
          pattern="[0-9]"
          value={quantity}
          onChange={e => {
            setQuantity(+e.target.value);
          }}
        />
      </Td>
      {accountType !== valueCorporate && (
        <>
          <Td>{getFormattedPricing(unitPrice)}</Td>
          <Td>{getFormattedPricing(unitPrice * quantity)}</Td>
        </>
      )}
    </>
  );
};

RatePlanTableSubRow.propTypes = {
  orderType: PropTypes.string.isRequired,
  productSelected: PropTypes.string.isRequired,
  accountType: PropTypes.string.isRequired,
  rateplanName: PropTypes.string.isRequired,
  deviceData: PropTypes.shape({
    fields: PropTypes.shape({
      deviceName: PropTypes.string,
      terms: PropTypes.arrayOf(
        PropTypes.shape({
          termName: PropTypes.string,
          termPrice: PropTypes.number,
          termPrice50PrecentUs: PropTypes.number
        })
      )
    })
  }).isRequired,
  fiftyPercentInUS: PropTypes.bool.isRequired,
  viewType: PropTypes.string.isRequired,
  ratePlans: PropTypes.arrayOf(PropTypes.object).isRequired,
  setRatePlans: PropTypes.func.isRequired,
  rateplanType: PropTypes.string.isRequired
};

export default RatePlanTableSubRow;
